

// import L from 'leaflet';

// class CustomDrawPolyline extends L.Draw.Polyline {
//   constructor(map, options) {
//     super(map, options);

//     // кастомного окна 
//     this._customTooltip = L.DomUtil.create('div', 'custom-draw-tooltip');
//     this._customTooltip.style.position = 'absolute';
//     this._customTooltip.style.background = 'linear-gradient(to bottom, #727272, #a7a7a7)'; // Градиентный фон
//     this._customTooltip.style.padding = '4px 8px';
//     this._customTooltip.style.borderRadius = '4px';
//     this._customTooltip.style.boxShadow = '0 0 6px rgba(0,0,0,0.2)';
//     this._customTooltip.style.pointerEvents = 'none';
//     this._customTooltip.style.zIndex = '1000';
//     this._customTooltip.style.display = 'none'; // По умолчанию скрыто
//     this._map.getContainer().appendChild(this._customTooltip);

//     this._map.on('dblclick', this._onDoubleClick, this);
//   }

//   _updateTooltip(latlng) {
   
//     if (!latlng || typeof latlng.lat !== 'number' || typeof latlng.lng !== 'number') {
//       return;
//     }

//     const point = this._map.latLngToContainerPoint(latlng);
//     this._customTooltip.style.left = point.x + 15 + 'px';
//     this._customTooltip.style.top = point.y + 15 + 'px';
//     this._customTooltip.style.display = 'block'; 

//     // Обновляем содержимое кастомного окна
//     const length = this._calculateLength(latlng);
//     const formattedLength = length < 1000 
//     ? `${length.toFixed(1)} м` 
//     : `${(length / 1000).toFixed(2)} км`;
  
//     this._customTooltip.innerHTML = `<span style="color: white;">Длина:</span> <span style="color: #fcc205;">${formattedLength}</span>`;
//   }

//   _calculateLength(lastLatLng) {
   
//     if (!this._latlngs || !Array.isArray(this._latlngs) || this._latlngs.length < 1) {
//       return 0; 
//     }

//     let length = 0;
//     for (let i = 1; i < this._latlngs.length; i++) {
//       length += this._latlngs[i - 1].distanceTo(this._latlngs[i]);
//     }

//     // Добавляем длину до курсора, если он передан
//     if (lastLatLng) {
//       const lastPoint = this._latlngs[this._latlngs.length - 1];
//       length += lastPoint.distanceTo(lastLatLng);
//     }

//     return length;
//   }

//   _onMouseMove(e) {
//     super._onMouseMove(e);
//     this._updateTooltip(e.latlng);
//   }

//   _vertexChanged(latlng, added) {
//     if (!this._latlngs) {
//       this._latlngs = [];
//     }
//     if (added) {
//       this._latlngs.push(latlng);
//     }
//     this._updateTooltip(latlng);
//   }

//   _finishShape() {
  
//     if (this._customTooltip) {
//       this._customTooltip.style.display = 'none'; 
//     }

//     const layer = L.polyline(this._latlngs, this.options);
//     this._map.addLayer(layer);

//     L.Draw.Feature.prototype._fireCreatedEvent.call(this, layer);
//     this.disable(); 
//   }

//   _onDoubleClick(e) {
//     this._finishShape();
//   }

//   disable() {
//     super.disable();
//     if (this._customTooltip) {
//       this._customTooltip.style.display = 'none';
//     }
//     this._map.off('dblclick', this._onDoubleClick, this);
//   }
// }

// export default CustomDrawPolyline;


import L from 'leaflet';

class CustomDrawPolyline extends L.Draw.Polyline {
  constructor(map, options) {
    super(map, options);

    // кастомное окно 
    this._customTooltip = L.DomUtil.create('div', 'custom-draw-tooltip');
    this._customTooltip.style.position = 'absolute';
    this._customTooltip.style.background = 'linear-gradient(to bottom, #727272, #a7a7a7)'; // Градиентный фон
    this._customTooltip.style.padding = '4px 8px';
    this._customTooltip.style.borderRadius = '4px';
    this._customTooltip.style.boxShadow = '0 0 6px rgba(0,0,0,0.2)';
    this._customTooltip.style.pointerEvents = 'none';
    this._customTooltip.style.zIndex = '1000';
    this._customTooltip.style.display = 'none'; // По умолчанию скрыто
    this._map.getContainer().appendChild(this._customTooltip);

    this._segmentMarkers = []; // Массив для хранения меток отрезков
    this._latlngs = []; // Инициализация массива координат
    this._map.on('dblclick', this._onDoubleClick, this);
  }

  _updateTooltip(latlng) {
    if (!latlng || typeof latlng.lat !== 'number' || typeof latlng.lng !== 'number') {
      return;
    }

    const point = this._map.latLngToContainerPoint(latlng);
    this._customTooltip.style.left = point.x + 15 + 'px';
    this._customTooltip.style.top = point.y + 15 + 'px';
    this._customTooltip.style.display = 'block';

    // Обновляем содержимое кастомного окна
    const length = this._calculateLength(latlng);
    const formattedLength = length < 1000 
      ? `${length.toFixed(1)} м` 
      : `${(length / 1000).toFixed(2)} км`;

    this._customTooltip.innerHTML = `<span style="color: white;">Длина:</span> <span style="color: #fcc205;">${formattedLength}</span>`;
  }

  _calculateLength(lastLatLng) {
    if (!this._latlngs || !Array.isArray(this._latlngs) || this._latlngs.length < 1) {
      return 0; 
    }

    let length = 0;
    for (let i = 1; i < this._latlngs.length; i++) {
      length += this._latlngs[i - 1].distanceTo(this._latlngs[i]);
    }

    if (lastLatLng) {
      const lastPoint = this._latlngs[this._latlngs.length - 1];
      length += lastPoint.distanceTo(lastLatLng);
    }

    return length;
  }

  _updateSegmentLabels() {
    // Проверяем наличие массива координат
    if (!this._latlngs || this._latlngs.length < 2) return;

    // Удаляем старые метки отрезков
    this._segmentMarkers.forEach(marker => this._map.removeLayer(marker));
    this._segmentMarkers = [];

    // Создаем метки для каждого отрезка
    for (let i = 1; i < this._latlngs.length; i++) {
      const start = this._latlngs[i - 1];
      const end = this._latlngs[i];
      const distance = start.distanceTo(end);
      const formattedDistance = distance < 1000 
        ? `${distance.toFixed(1)} м` 
        : `${(distance / 1000).toFixed(2)} км`;

      const midPoint = L.latLng(
        (start.lat + end.lat) / 2,
        (start.lng + end.lng) / 2
      );

      const marker = L.marker(midPoint, {
        icon: L.divIcon({
          className: 'segment-label',
          html: `<div style="
            display: inline-block; 
            background: linear-gradient(to bottom, #727272, #a7a7a7); 
            color: #fcc205;
            padding: 2px 4px; 
            border-radius: 3px; 
            box-shadow: 0 0 3px rgba(0,0,0,0.3);
            white-space: nowrap; 
         ">
            ${formattedDistance}
          </div>`
        }),
        interactive: false
      }).addTo(this._map);
      
      this._segmentMarkers.push(marker);
    }
  }

  _onMouseMove(e) {
    super._onMouseMove(e);
    this._updateTooltip(e.latlng);
    this._updateSegmentLabels(); // Обновляем метки отрезков
  }

  _vertexChanged(latlng, added) {
    if (!this._latlngs) {
      this._latlngs = [];
    }
    if (added) {
      this._latlngs.push(latlng);
    }
    this._updateTooltip(latlng);
    this._updateSegmentLabels(); // Обновляем метки отрезков при добавлении точки
  }

  _finishShape() {
    if (this._customTooltip) {
      this._customTooltip.style.display = 'none';
    }

    const layer = L.polyline(this._latlngs, this.options);
    this._map.addLayer(layer);

    L.Draw.Feature.prototype._fireCreatedEvent.call(this, layer);
    this.disable(); 
  }

  _onDoubleClick(e) {
    this._finishShape();
  }

  disable() {
    super.disable();
    if (this._customTooltip) {
      this._customTooltip.style.display = 'none';
    }
    this._map.off('dblclick', this._onDoubleClick, this);

    // Удаляем метки отрезков
    this._segmentMarkers.forEach(marker => this._map.removeLayer(marker));
    this._segmentMarkers = [];
  }
}

export default CustomDrawPolyline;